'use strict';
const {cardTypes, testOrder} = require('./credit_card/types');
const matches = require('./credit_card/matches');

const hasMatch = (ccString, patterns) => patterns.filter((pattern) => matches(ccString, pattern)).length;
const CREDIT_CARD_PCI_BIN_LENGTH = 8;

module.exports = {
    'isValidCreditCard': function(cardNumber) {
        return /^[0-9]{10,19}$/.test(cardNumber);
    },
    isValidPCICreditCardBin(cardNumber) {
        return /^[0-9]{8,19}$/.test(cardNumber);
    },
    creditCardType(ccString) {
        let matched = '';

        if (Odigeo._.isEmpty(ccString)) {
            return matched;
        } else {
            for (const type of testOrder) {
                const ccConfig = cardTypes[type];

                if (ccConfig && hasMatch(ccString, ccConfig.patterns)) {
                    matched = ccConfig.code;
                    break;
                }
            }
            return matched;
        }
    },
    getBinCCNumber(number) {
        return number.replace(/\s/g, '').substring(0, 10);
    },
    getPCIBinCCNumber(number) {
        return number.replace(/\s/g, '').substring(0, CREDIT_CARD_PCI_BIN_LENGTH);
    },
};
